import { Component } from 'react';
import Raven from 'raven-js';
import { Metrics } from '../Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
const safeSerializeError = error => {
  try {
    // ensure that some version of error gets included even for self-recursive errors
    return JSON.stringify(error);
  } catch (e) {
    return `${error}`;
  }
};
export class ErrorBoundary extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      hasError: false
    };
    this.retry = () => {
      Metrics.counter('error-boundary-retried', {
        package: this.failSafeCallerPackage
      }).increment();
      this.setState({
        hasError: false
      });
    };
  }
  static getDerivedStateFromError() {
    return {
      hasError: true
    };
  }
  get failSafeCallerPackage() {
    var _failSafeCallerPacka;
    return (_failSafeCallerPacka = this.props.__failSafeCallerPackage) !== null && _failSafeCallerPacka !== void 0 ? _failSafeCallerPacka : 'unknown';
  }
  componentDidCatch(error, errorInfo) {
    const {
      onError
    } = this.props;
    try {
      Metrics.counter('error-boundary-caught', {
        package: this.failSafeCallerPackage
      }).increment();
      Raven.captureException(new Error('Error boundary caught', {
        cause: error
      }), {
        extra: {
          package: this.failSafeCallerPackage,
          error: safeSerializeError(error),
          errorInfo
        }
      });
      onError === null || onError === void 0 || onError(error, errorInfo);
    } catch (callbackError) {
      Raven.captureException(callbackError instanceof Error ? callbackError : new Error(String(callbackError)));
    }
  }
  render() {
    const {
      ErrorComponent,
      children
    } = this.props;
    if (this.state.hasError) {
      return ErrorComponent ? /*#__PURE__*/_jsx(ErrorComponent, {
        retry: this.retry
      }) : null;
    }
    return children;
  }
}